import React from 'react'
import PropTypes from 'prop-types'

class WPCOMLoader extends React.Component {
	render() {
		const { message } = this.props
		return <div className="wpcom">
			<div className="wpcom-migration-container">
				<main className="wpcom-migration-content-full-width">
					<h1>{message}</h1>
					<div className="wpcom-progress-bar wpcom-migration__progress">
						<div className="wpcom-progress-bar__animated-line"></div>
					</div>
				</main>
			</div>
		</div>
	}
}

WPCOMLoader.propTypes = {
	message: PropTypes.string
}

export default WPCOMLoader
